export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center border border-foreground-300 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-foreground-600 mb-8">
          About Us
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 leading-snug mb-8">
          We Bring Color to Your
          <br />
          <span className="text-primary-500">Home & Business</span>
        </h2>

        <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-10">
          Castillo Painting Inc. has been serving the Corona community and
          surrounding counties with pride and dedication. From interior walls
          to exterior facades, residential homes to commercial properties, we
          deliver flawless results that stand the test of time. Our team is
          committed to quality, professionalism, and your complete satisfaction.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {[
            { number: "10+", label: "Years Experience" },
            { number: "500+", label: "Projects Completed" },
            { number: "5", label: "Counties Served" },
            { number: "100%", label: "Satisfaction Rate" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-medium text-primary-500 mb-1">
                {stat.number}
              </p>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}